import { Nullable } from '@clearverify/types';

export const DEFAULT_DEBOUNCE = 600;

export const TableSearchFormField = {
  searchValue: 'searchValue',
  searchCategory: 'searchCategory',
} as const;

export type TableSearchFormValues = {
  [TableSearchFormField.searchValue]: Nullable<string>;
  [TableSearchFormField.searchCategory]: Nullable<string>;
};

export const TABLE_SEARCH_FORM_INITIAL_VALUES: TableSearchFormValues = {
  [TableSearchFormField.searchValue]: null,
  [TableSearchFormField.searchCategory]: null,
};
